import {
  Visit as AWVisit,
  Transfer as AWTransfer,
  VisitSummary as AWVisitSummary,
  ChatItem as AWChatItem,
  ChatReport as AWChatReport,
  ContextElements as AWContextElements,
  VideoContext as AWVideoContext,
  VideoConsole as AWVideoConsole,
  VisitRx as AWVisitRx,
  ConsumerFeedbackQuestion as AWConsumerFeedbackQuestion
} from 'lib/amwell/sdk/types';
import { Disposition, EndReason, UserType } from 'lib/amwell/sdk/enums';
import { VisitType, VisitStep } from 'lib/amwell/client/types';

// Types
export type Transfer = AWTransfer;
export type Visit = AWVisit;
export type VisitSummary = AWVisitSummary;
export type ChatItem = AWChatItem;
export type ChatReport = AWChatReport;
export type ContextElements = Pick<
  AWContextElements,
  'messages' | 'consoleWrapperAttachPoints' | 'videoConsoleContainer'
>;
export type VideoContext = AWVideoContext;
export type VideoConsole = AWVideoConsole;
export type VisitRx = AWVisitRx;
export type ConsumerFeedbackQuestion = AWConsumerFeedbackQuestion;

// Enums
export { EndReason };
export { Disposition };
export { UserType };
export { VisitType };
export { VisitStep };

// Action Types
export interface UpdateCouponCodePayload {
  couponCode: string;
}

export interface VisitPayload {
  visit: Visit;
}

export interface VisitEmitterPayload {
  visit: Visit;
  type: VisitType;
  step: VisitStep;
}

export interface SendVisitSummaryPayload {
  hipaaNoticeAccepted: boolean;
  emailAddresses?: string[];
  faxNumbers?: string[];
}

export interface SetupWaitingRoomAlertsPayload {
  phoneNumber: string;
  providerReadyAlert?: boolean;
  movedUpInQueueAlert?: boolean;
}

export interface SubmitVisitFeedbackPayload {
  providerRating: number;
  engagementRating: number;
  feedbackQuestion: string;
  feedbackAnswer: string;
}

export interface SubmitContactInfoForFeedbackPayload {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface AddChatMessagePayload {
  message: string;
  lastPolledChatOrdinal: number;
}

export interface DeclineSuggestedTransferPayload {
  dontAskAgain: boolean;
}

export interface StartWebRTCVisitPayload {
  visit: Visit;
  contextElements: ContextElements;
}
